/*
  Gift designer — the bride's copy of the Bride Edition customizer.

  Ported from sections/kf-customizer.liquid (live theme, 2026-10-13) and kept deliberately
  separate: nothing here reads or changes the live customizer's files, so the shop's normal
  sales cannot be affected by this page. Differences from the original:
    - no prices, no cart, no socks, no "edit from cart" — the pair is already paid for;
    - every change is reported through onChange() so the page can autosave it;
    - the last button says "Continue to delivery" instead of "Add to cart";
    - sizes show US and EU together.
  Layer rendering, the click-to-open hit map and the name layout are the original logic.

  API:
    var d = GiftDesigner.mount(rootEl, { config, assetBase, icons, initial, onChange, onDone });
    d.get()        -> { size, zones:[{z,o}], name, date, font, textColor }   (same shape as _kf_design)
    d.set(design)
    d.namePos()    -> "x%,y%,rotation,size%" for the order (same as _kf_name_pos), or ''
    d.relayout()
    GiftDesigner.preview(el, config, assetBase, design)  — static picture of a design
*/
(function () {
  'use strict';

  var NAME_DROP = 0.45; // same vertical nudge as the live customizer and the cart picture
  var WHITE = '#f2f1ec';

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function isPlain(o) { return !o || /^(no-custom|none|without-color)$/i.test(o.key || ''); }
  function byKey(list, key) { for (var i = 0; i < (list || []).length; i++) if (list[i].key === key) return list[i]; return null; }
  function famOf(f) { return f && f.family ? "'" + f.family + "',cursive" : 'cursive'; }
  function sizeLabel(o) { return o ? 'US ' + o.us + ' · EU ' + o.eu : ''; }

  var fontsLoaded = {};
  function loadFonts(cfg, asset, extraCss) {
    var css = (cfg.text.fonts || []).filter(function (f) { return f.family && f.asset && !fontsLoaded[f.family]; }).map(function (f) {
      fontsLoaded[f.family] = true;
      var fmt = /\.otf$/i.test(f.asset) ? 'opentype' : 'truetype';
      return "@font-face{font-family:'" + f.family + "';src:url('" + asset(f.asset) + "') format('" + fmt + "');font-display:swap;}";
    }).join('') + (extraCss || '');
    if (css) { var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s); }
  }

  // Name centre comes from the config (canvas units); long names shrink to maxWidth. Same maths as the original.
  function layoutNameIn(inner, nameEl, cfg) {
    var w = inner.clientWidth || 1, s = w / cfg.canvas.w;
    var innerH = inner.clientHeight || 0, imgH = cfg.canvas.h * s;
    var padY = innerH > imgH ? (innerH - imgH) / 2 : 0;
    nameEl.style.left = (cfg.text.pos.x * s) + 'px';
    nameEl.style.top = (padY + cfg.text.pos.y * s) + 'px';
    nameEl.style.transform = 'translate(-50%,calc(-50% + ' + NAME_DROP + 'em)) rotate(' + (cfg.text.pos.rotation || 0) + 'deg)';
    var size = cfg.text.fontSizePx * s;
    nameEl.style.fontSize = size + 'px';
    var limit = (cfg.text.pos.maxWidth || 0) * s;
    if (limit > 0) { var actual = nameEl.scrollWidth; if (actual > limit) nameEl.style.fontSize = (size * limit / actual) + 'px'; }
  }

  // ---------- static picture (review screen, summary card) ----------
  function preview(el, cfg, assetBase, design) {
    var asset = function (f) { return assetBase + f; };
    loadFonts(cfg, asset);
    el.innerHTML = '';
    el.classList.add('kfx-pv');
    el.style.background = (cfg.canvas && cfg.canvas.bg) || '#ececec';
    var inner = document.createElement('div');
    inner.className = 'kfx-pv__inner';
    inner.style.aspectRatio = cfg.canvas.w + '/' + cfg.canvas.h;
    if (cfg.canvas.fit && cfg.canvas.fit !== 1) inner.style.transform = 'scale(' + cfg.canvas.fit + ')';
    var add = function (src) { var im = document.createElement('img'); im.alt = ''; im.src = asset(src); im.className = 'kfx-layer'; inner.appendChild(im); };
    add(cfg.baseAsset);
    var picked = {};
    (design.zones || []).forEach(function (z) { picked[z.z] = z.o; });
    cfg.zones.forEach(function (z) { var o = byKey(z.options, picked[z.key]) || z.options[0]; add(o.asset); });
    var name = String(design.name || '').trim();
    if (name) {
      var n = document.createElement('div');
      n.className = 'kfx-name';
      n.textContent = name;
      var font = byKey(cfg.text.fonts, design.font) || cfg.text.fonts[0];
      var col = byKey(cfg.text.colors, design.textColor) || cfg.text.colors[0];
      n.style.fontFamily = famOf(font);
      n.style.color = col.hex;
      inner.appendChild(n);
      var lay = function () { if (inner.clientWidth) layoutNameIn(inner, n, cfg); };
      if (window.ResizeObserver) new ResizeObserver(lay).observe(inner);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(lay);
      requestAnimationFrame(lay);
    }
    el.appendChild(inner);
  }

  // ---------- the interactive designer ----------
  function mount(root, opts) {
    var cfg = opts.config;
    var asset = function (f) { return opts.assetBase + f; };
    var ICONS = opts.icons || {};
    var ICON_BG = { name: '#fdfbf7', date: '#fdfcfa', font: '#fcfbf9', plain: '#e8e7e7' };
    var onChange = opts.onChange || function () {};
    var mq = window.matchMedia('(min-width:900px)');
    var FIT = (cfg.canvas && cfg.canvas.fit) || 1;
    var MAXN = cfg.text.maxLength || 18;

    loadFonts(cfg, asset, opts.extraFontCss);

    root.classList.add('kfx');
    root.innerHTML =
      '<div class="kfx-top kfx-m"><div class="kfx-top__l"><span class="kfx-eyebrow">Your design</span><span class="kfx-colorway" data-kf-colorway></span></div>' +
      '<div class="kfx-top__r"><span class="kfx-saved" data-kf-saved></span></div></div>' +
      '<div class="kfx-main">' +
        '<div class="kfx-stage" data-kf-stage><div class="kfx-canvas" data-kf-canvas><div class="kfx-canvas__inner" data-kf-inner>' +
          '<img class="kfx-layer kfx-layer--base" data-kf-base alt="" fetchpriority="high">' +
          '<div class="kfx-layers" data-kf-layers></div><div class="kfx-name" data-kf-name hidden></div>' +
        '</div><div class="kfx-skeleton" data-kf-loading><div class="kfx-skeleton__box"></div><span>Loading your pair…</span></div></div></div>' +
        '<div class="kfx-panel">' +
          '<div class="kfx-dhead kfx-d"><div class="kfx-dhead__row"><div><div class="kfx-eyebrow">Bride Edition · your gift</div>' +
            '<div class="kfx-dtitle">Design your pair</div></div>' +
            '<div class="kfx-dhead__prog"><div class="kfx-eyebrow">Your palette</div><div class="kfx-progress" data-kf-dcolorway></div></div></div>' +
            '<div class="kfx-dsub" data-kf-dsub></div><div class="kfx-saved kfx-saved--d" data-kf-dsaved></div></div>' +
          '<div class="kfx-panel__head kfx-m"><button type="button" class="kfx-back" data-kf-back hidden aria-label="Back"><span class="kfx-back__arrow"></span></button>' +
            '<div class="kfx-panel__titles"><div class="kfx-panel__title" data-kf-title></div><div class="kfx-panel__sub" data-kf-sub></div></div></div>' +
          '<div class="kfx-panel__body" data-kf-body></div>' +
          '<div class="kfx-cta-wrap"><div class="kfx-toast" data-kf-toast hidden><span class="kfx-toast__i">!</span><span data-kf-toast-msg></span>' +
            '<button type="button" class="kfx-toast__x" data-kf-toast-x aria-label="Close">✕</button></div>' +
            '<button type="button" class="kfx-cta" data-kf-cta><span data-kf-cta-content></span></button></div>' +
        '</div>' +
      '</div>';

    var q = function (s) { return root.querySelector(s); };
    var el = {
      colorway: q('[data-kf-colorway]'), dcolorway: q('[data-kf-dcolorway]'), dsub: q('[data-kf-dsub]'),
      saved: q('[data-kf-saved]'), dsaved: q('[data-kf-dsaved]'),
      base: q('[data-kf-base]'), layers: q('[data-kf-layers]'), nameOv: q('[data-kf-name]'), inner: q('[data-kf-inner]'),
      canvas: q('[data-kf-canvas]'), loading: q('[data-kf-loading]'),
      back: q('[data-kf-back]'), title: q('[data-kf-title]'), sub: q('[data-kf-sub]'),
      body: q('[data-kf-body]'), cta: q('[data-kf-cta]'), ctaC: q('[data-kf-cta-content]'),
      toast: q('[data-kf-toast]'), toastMsg: q('[data-kf-toast-msg]')
    };

    el.inner.style.aspectRatio = cfg.canvas.w + '/' + cfg.canvas.h;
    if (FIT !== 1) el.inner.style.transform = 'scale(' + FIT + ')';
    if (cfg.canvas.bg) { q('[data-kf-stage]').style.background = cfg.canvas.bg; q('.kfx-top').style.background = cfg.canvas.bg; }

    var STEPS = [{ id: 'size', kind: 'size', name: 'Size' }];
    cfg.zones.forEach(function (z) { STEPS.push({ id: z.key, kind: 'color', name: z.name, zone: z }); });
    STEPS.push({ id: 'personalize', kind: 'personalize', name: 'Personalize' });

    var st = { open: null, persTab: null, sel: {}, size: null, name: '', date: '', textColor: cfg.text.colors[0], font: cfg.text.fonts[0] };
    cfg.zones.forEach(function (z) { st.sel[z.key] = z.options[0]; });

    function changed() { try { onChange(api.get()); } catch (e) { console.error(e); } }

    // ---------- stage ----------
    el.base.addEventListener('load', function () { el.loading.style.display = 'none'; });
    el.base.src = asset(cfg.baseAsset);
    if (el.base.complete && el.base.naturalWidth) el.loading.style.display = 'none';
    var layerEls = {};
    cfg.zones.forEach(function (z) {
      var im = document.createElement('img'); im.alt = ''; im.loading = 'eager'; im.src = asset(z.options[0].asset);
      el.layers.appendChild(im); layerEls[z.key] = im;
    });

    // Clicking the shoe opens that zone's step. Map built once from the plain layers (shape never changes).
    var HIT = { ready: false, w: 0, h: 0, masks: {} };
    (function buildHitMap() {
      var W = 340, H = Math.max(1, Math.round(W * cfg.canvas.h / cfg.canvas.w)), pending = cfg.zones.length;
      var done = function () { if (--pending > 0) return; HIT.ready = true; HIT.w = W; HIT.h = H; if (Object.keys(HIT.masks).length) el.inner.dataset.kfHit = '1'; };
      cfg.zones.forEach(function (z) {
        var im = layerEls[z.key];
        var build = function () {
          try {
            var c = document.createElement('canvas'); c.width = W; c.height = H;
            var ctx = c.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(im, 0, 0, W, H);
            var d = ctx.getImageData(0, 0, W, H).data, m = new Uint8Array(W * H);
            for (var i = 0; i < W * H; i++) m[i] = d[i * 4 + 3] > 28 ? 1 : 0;
            HIT.masks[z.key] = m;
          } catch (e) { /* no CORS from the CDN — the shoe just is not clickable */ }
          done();
        };
        if (im.complete && im.naturalWidth) build();
        else { im.addEventListener('load', build, { once: true }); im.addEventListener('error', done, { once: true }); }
      });
    })();

    function flashZone(key) {
      var im = layerEls[key]; if (!im) return;
      im.classList.remove('kfx-zone-flash'); void im.offsetWidth; im.classList.add('kfx-zone-flash');
      setTimeout(function () { im.classList.remove('kfx-zone-flash'); }, 320);
    }
    el.inner.addEventListener('click', function (ev) {
      if (!HIT.ready) return;
      var r = el.base.getBoundingClientRect(); if (!r.width || !r.height) return;
      var x = Math.floor((ev.clientX - r.left) / r.width * HIT.w), y = Math.floor((ev.clientY - r.top) / r.height * HIT.h);
      if (x < 0 || y < 0 || x >= HIT.w || y >= HIT.h) return;
      var idx = y * HIT.w + x;
      for (var i = cfg.zones.length - 1; i >= 0; i--) {
        var key = cfg.zones[i].key, m = HIT.masks[key];
        if (m && m[idx]) { if (st.open !== key) setOpen(key); else flashZone(key); return; }
      }
    });

    function layoutName() { if (el.inner.clientWidth) layoutNameIn(el.inner, el.nameOv, cfg); }
    function applyFont(f) { el.nameOv.style.fontFamily = famOf(f); layoutName(); }
    function updateName() {
      var v = st.name.trim();
      if (v) { el.nameOv.textContent = v; el.nameOv.hidden = false; layoutName(); } else el.nameOv.hidden = true;
    }
    el.nameOv.style.color = st.textColor.hex;
    applyFont(st.font);
    if (window.ResizeObserver) new ResizeObserver(layoutName).observe(el.canvas);
    window.addEventListener('resize', layoutName);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { try { layoutName(); } catch (e) {} });

    function colorwayName() {
      var picked = cfg.zones.filter(function (z) { return !isPlain(st.sel[z.key]); }).map(function (z) { return st.sel[z.key].name; });
      if (!picked.length) return 'Classic white';
      if (picked.length === 1) return 'White + ' + picked[0];
      if (picked.length === 2) return picked[0] + ' + ' + picked[1];
      return 'White + ' + picked.length + ' accents';
    }
    function refreshTop() { var n = colorwayName(); el.colorway.textContent = n; el.dcolorway.textContent = n; }

    function isDesktop() { return mq.matches; }
    function markPressed(wrap, b) {
      wrap.querySelectorAll('.kfx-color,.kfx-size').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); var t = x.querySelector('.kfx-color__tick'); if (t) t.remove(); });
      b.setAttribute('aria-pressed', 'true');
      var c = b.querySelector('.kfx-color__c');
      if (c && !c.querySelector('.kfx-color__tick')) { var tk = document.createElement('span'); tk.className = 'kfx-color__tick'; tk.textContent = '✓'; c.appendChild(tk); }
    }
    function refreshAccRow(id) {
      var row = root.querySelector('.kfx-acc[data-step="' + id + '"]'); if (!row) return;
      var s = STEPS.filter(function (x) { return x.id === id; })[0];
      var sum = row.querySelector('.kfx-acc__sum'); if (sum) sum.textContent = accSummary(s);
      var th = row.querySelector('.kfx-acc__thumb'); if (th) th.innerHTML = accThumb(s) + ((s.kind === 'size' && st.size) ? '<span class="kfx-acc__done">✓</span>' : '');
    }

    // ---------- option builders ----------
    function plainBg() { return "background-image:url('" + ICONS.plain + "');background-size:cover;background-position:center;"; }
    function buildColors(zone) {
      var wrap = document.createElement('div'); wrap.className = 'kfx-colors kfx-strip';
      zone.options.forEach(function (opt) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kfx-color';
        var selected = st.sel[zone.key].key === opt.key; b.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var bg = isPlain(opt) ? plainBg() : (opt.swatch ? "background-image:url('" + asset(opt.swatch) + "');background-size:cover;background-position:center;" : 'background:' + WHITE + ';');
        b.innerHTML = '<div class="kfx-color__c" style="' + bg + '">' + (selected ? '<span class="kfx-color__tick">✓</span>' : '') + '</div>' +
          '<span class="kfx-color__n">' + escapeHtml(opt.name) + '</span>';
        b.addEventListener('click', function () {
          if (st.sel[zone.key].key === opt.key) return;
          st.sel[zone.key] = opt; layerEls[zone.key].src = asset(opt.asset); flashZone(zone.key); refreshTop();
          markPressed(wrap, b); refreshAccRow(zone.key); changed();
        });
        wrap.appendChild(b);
      });
      return wrap;
    }

    function buildSize() {
      var frag = document.createDocumentFragment();
      var g = document.createElement('div'); g.className = 'kfx-size-guide';
      g.innerHTML = '<span>Runs true to size · Not sure? <a class="kfx-sizelink" href="/pages/sizing-chart" target="_blank" rel="noopener"><span class="link">See size guide</span></a></span>';
      frag.appendChild(g);
      var wrap = document.createElement('div'); wrap.className = 'kfx-sizes kfx-strip';
      cfg.size.options.forEach(function (o) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kfx-size';
        b.setAttribute('aria-pressed', st.size && st.size.key === o.key ? 'true' : 'false');
        b.setAttribute('aria-label', 'US women ' + o.us + ', EU ' + o.eu);
        b.innerHTML = '<span class="kfx-size__lab">US WOMENS</span><span class="kfx-size__w">' + escapeHtml(o.us) + '</span><span class="kfx-size__d"></span><span class="kfx-size__lab">EU ' + escapeHtml(o.eu) + '</span>';
        b.addEventListener('click', function () { st.size = o; el.toast.hidden = true; markPressed(wrap, b); refreshAccRow('size'); changed(); setOpen(null); });
        wrap.appendChild(b);
      });
      frag.appendChild(wrap);
      return frag;
    }

    function persSubs() {
      return [{ key: 'name', name: cfg.text.label || 'Name' }, { key: 'date', name: 'Date' }, { key: 'font', name: 'Font' }, { key: 'color', name: 'Color' }];
    }
    function persSubName(k) { var s = persSubs().filter(function (x) { return x.key === k; })[0]; return s ? s.name : 'Personalize'; }
    var HINTS = { name: 'Type the name for the shoe', date: 'Optional — goes on the other sneaker', font: 'Pick a script for the name', color: 'Pick a color for the name' };

    function buildPersonalize() { return st.persTab ? buildPersPanel(st.persTab) : buildPersTiles(); }
    function buildPersTiles() {
      var wrap = document.createElement('div'); wrap.className = 'kfx-strip kfx-steps';
      persSubs().forEach(function (s) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kfx-step';
        var th = '<div class="kfx-step__thumb">';
        if (s.key === 'color') th += '<span class="kfx-step__chip" style="background:' + st.textColor.hex + '"></span>';
        else th += '<span class="kfx-step__ic" style="background-image:url(\'' + ICONS[s.key] + '\');background-color:' + ICON_BG[s.key] + '"></span>';
        b.innerHTML = th + '</div><span class="kfx-step__name">' + escapeHtml(s.name) + '</span><span class="kfx-step__u"></span>';
        b.addEventListener('click', function () { st.persTab = s.key; render(); });
        wrap.appendChild(b);
      });
      return wrap;
    }
    function buildPersPanel(kind) {
      var frag = document.createDocumentFragment();
      if (isDesktop()) {
        var bk = document.createElement('button'); bk.type = 'button'; bk.className = 'kfx-pback';
        bk.innerHTML = '<span class="kfx-back__arrow"></span><span>' + escapeHtml(persSubName(kind)) + '</span>';
        bk.addEventListener('click', function () { st.persTab = null; render(); });
        frag.appendChild(bk);
      }
      if (kind === 'name' || kind === 'date') frag.appendChild(buildPersInput(kind));
      else if (kind === 'font') frag.appendChild(buildFontStrip());
      else frag.appendChild(buildTextColorStrip());
      return frag;
    }
    function buildPersInput(kind) {
      var d = document.createElement('div'); d.className = 'kfx-pers';
      if (kind === 'name') {
        d.innerHTML = '<div class="kfx-inputwrap"><input class="kfx-input" data-n type="text" maxlength="' + MAXN + '" autocomplete="off" placeholder="' + escapeHtml(cfg.text.placeholder || '') + '" value="' + escapeHtml(st.name) + '"><span class="kfx-counter" data-nc>' + st.name.length + '/' + MAXN + '</span></div>';
        var ni = d.querySelector('[data-n]'), nc = d.querySelector('[data-nc]');
        ni.addEventListener('input', function () { st.name = ni.value.slice(0, MAXN); nc.textContent = st.name.length + '/' + MAXN; updateName(); refreshAccRow('personalize'); changed(); });
      } else {
        var maxD = (cfg.date && cfg.date.maxLength) || 24;
        d.innerHTML = '<label class="kfx-plabel">' + escapeHtml((cfg.date && cfg.date.label) || 'Date') + '</label>' +
          '<div class="kfx-inputwrap"><input class="kfx-input" data-d type="text" maxlength="' + maxD + '" autocomplete="off" placeholder="' + escapeHtml((cfg.date && cfg.date.placeholder) || '') + '" value="' + escapeHtml(st.date) + '"></div>';
        var di = d.querySelector('[data-d]');
        di.addEventListener('input', function () { st.date = di.value.slice(0, maxD); changed(); });
      }
      return d;
    }
    function buildFontStrip() {
      var wrap = document.createElement('div'); wrap.className = 'kfx-strip kfx-colors';
      cfg.text.fonts.forEach(function (f) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kfx-color kfx-color--font';
        b.setAttribute('aria-pressed', st.font.key === f.key ? 'true' : 'false');
        b.innerHTML = '<span class="kfx-color__c"><span class="kfx-font__s" style="font-family:' + famOf(f) + '">' + escapeHtml(st.name.trim() || cfg.text.sample || 'Mrs. Mary') + '</span>' +
          (st.font.key === f.key ? '<span class="kfx-color__tick">✓</span>' : '') + '</span><span class="kfx-color__n">' + escapeHtml(f.name) + '</span>';
        b.addEventListener('click', function () { st.font = f; applyFont(f); markPressed(wrap, b); refreshAccRow('personalize'); changed(); });
        wrap.appendChild(b);
      });
      return wrap;
    }
    function swatchStyle(col) {
      return col && col.swatch
        ? "background-image:url('" + asset(col.swatch) + "');background-size:cover;background-position:center;background-repeat:no-repeat;background-origin:border-box;background-clip:border-box"
        : 'background:' + ((col && col.hex) || '#111');
    }
    function buildTextColorStrip() {
      var wrap = document.createElement('div'); wrap.className = 'kfx-strip kfx-colors';
      cfg.text.colors.forEach(function (col) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kfx-color';
        b.setAttribute('aria-pressed', st.textColor.key === col.key ? 'true' : 'false');
        b.innerHTML = '<span class="kfx-color__c" style="' + swatchStyle(col) + '">' + (st.textColor.key === col.key ? '<span class="kfx-color__tick">✓</span>' : '') +
          '</span><span class="kfx-color__n">' + escapeHtml(col.name) + '</span>';
        b.addEventListener('click', function () { st.textColor = col; el.nameOv.style.color = col.hex; markPressed(wrap, b); changed(); });
        wrap.appendChild(b);
      });
      return wrap;
    }
    // Wide scripts did not fit the round sample; shrink the sample instead of cutting it (as the original).
    function fitFontSamples() {
      var fit = function () {
        root.querySelectorAll('.kfx-font__s').forEach(function (s) {
          var box = s.parentNode.clientWidth - 10; if (box <= 0) return;
          var size = 20; s.style.fontSize = size + 'px';
          for (var i = 0; i < 24 && s.scrollWidth > box && size > 8; i++) { size -= 1; s.style.fontSize = size + 'px'; }
        });
      };
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { requestAnimationFrame(fit); });
    }

    function accSummary(s) {
      if (s.kind === 'size') return st.size ? sizeLabel(st.size) : 'Required';
      if (s.kind === 'personalize') return st.name.trim() || 'Add a name';
      var o = st.sel[s.zone.key]; return isPlain(o) ? '' : o.name;
    }
    function accThumb(s) {
      if (s.kind === 'size') return '<span class="kfx-acc__glyph">' + (st.size ? escapeHtml(st.size.us) : 'US') + '</span>';
      if (s.kind === 'personalize') return '<span class="kfx-acc__glyph" style="font-family:' + famOf(st.font) + ';font-size:22px">Aa</span>';
      var o = st.sel[s.zone.key];
      if (isPlain(o)) return '<span class="kfx-acc__chip" style="background-image:url(\'' + ICONS.plain + '\');background-size:cover"></span>';
      return '<span class="kfx-acc__chip" style="background-image:url(\'' + asset(o.swatch) + '\');background-size:cover"></span>';
    }

    var INTRO = 'Add pearls or rhinestones to any zone — classic white is beautiful too. Everything is included in your gift.';

    // ---------- render ----------
    function render() {
      var cur = STEPS.filter(function (s) { return s.id === st.open; })[0];
      var mode = cur ? cur.kind : 'steps';
      refreshTop();
      renderCta(cur, mode);
      if (isDesktop()) {
        el.dsub.textContent = st.size ? INTRO : INTRO + ' Only your size is required.';
        el.body.innerHTML = ''; el.body.appendChild(buildAccordion());
      } else {
        el.back.hidden = !cur;
        var sub = (mode === 'personalize' && st.persTab) ? st.persTab : null;
        el.title.textContent = cur ? (sub ? persSubName(sub) : cur.name) : 'Design your pair';
        el.sub.textContent = cur
          ? (sub ? HINTS[sub] : (mode === 'color' ? 'Pick a style for this zone' : (mode === 'size' ? 'US women’s sizes, EU below' : 'Add a name & pick a font')))
          : (st.size ? 'Customize any zone you like' : 'Only size is required — customize any zone you like');
        el.body.innerHTML = '';
        if (!cur) el.body.appendChild(buildSteps());
        else if (mode === 'color') el.body.appendChild(buildColors(cur.zone));
        else if (mode === 'size') el.body.appendChild(buildSize());
        else el.body.appendChild(buildPersonalize());
        var strip = el.body.querySelector('.kfx-strip');
        if (strip) requestAnimationFrame(function () { var a = strip.querySelector('[aria-pressed="true"]'); if (a && a.scrollIntoView) a.scrollIntoView({ inline: 'nearest', block: 'nearest' }); });
      }
      fitFontSamples();
    }
    function buildSteps() {
      var wrap = document.createElement('div'); wrap.className = 'kfx-strip kfx-steps';
      STEPS.forEach(function (s) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'kfx-step';
        var th = '<div class="kfx-step__thumb">';
        if (s.kind === 'size') th += '<span class="kfx-step__glyph">' + (st.size ? escapeHtml(st.size.us) : 'US') + '</span>';
        else if (s.kind === 'personalize') th += '<span class="kfx-step__glyph" style="font-family:' + famOf(st.font) + ';font-size:26px">Aa</span>';
        else {
          var so = st.sel[s.zone.key];
          th += isPlain(so) ? '<span class="kfx-step__chip" style="background-image:url(\'' + ICONS.plain + '\');background-size:cover"></span>'
            : '<span class="kfx-step__chip" style="background-image:url(\'' + asset(so.swatch) + '\');background-size:cover"></span>';
        }
        th += '</div>';
        var req = (s.kind === 'size' && !st.size) ? '<span class="kfx-step__req">Required</span>' : '';
        b.innerHTML = th + '<span class="kfx-step__name">' + escapeHtml(s.name) + '</span>' + req + '<span class="kfx-step__u"></span>';
        b.addEventListener('click', function () { st.open = s.id; st.persTab = null; if (layerEls[s.id]) flashZone(s.id); render(); });
        wrap.appendChild(b);
      });
      return wrap;
    }
    function buildAccordion() {
      var box = document.createElement('div');
      STEPS.forEach(function (s) {
        var open = st.open === s.id;
        var acc = document.createElement('div'); acc.className = 'kfx-acc'; acc.dataset.step = s.id; acc.setAttribute('data-active', open ? 'true' : 'false');
        var row = document.createElement('button'); row.type = 'button'; row.className = 'kfx-acc__row';
        var isReq = s.kind === 'size' && !st.size;
        row.innerHTML = '<span class="kfx-acc__thumb">' + accThumb(s) + ((s.kind === 'size' && st.size) ? '<span class="kfx-acc__done">✓</span>' : '') + '</span>' +
          '<span class="kfx-acc__name">' + escapeHtml(s.name) + '</span>' +
          '<span class="kfx-acc__sum' + (isReq ? ' kfx-acc__sum--req' : '') + '">' + escapeHtml(accSummary(s)) + '</span>' +
          '<span class="kfx-acc__chev' + (open ? ' is-open' : '') + '"></span>';
        row.addEventListener('click', function () { setOpen(open ? null : s.id); });
        acc.appendChild(row);
        if (open) {
          var body = document.createElement('div'); body.className = 'kfx-acc__body';
          if (s.kind === 'color') body.appendChild(buildColors(s.zone));
          else if (s.kind === 'size') body.appendChild(buildSize());
          else body.appendChild(buildPersonalize());
          acc.appendChild(body);
        }
        box.appendChild(acc);
      });
      return box;
    }
    function scrollAccIntoView(id) {
      requestAnimationFrame(function () { var a = root.querySelector('.kfx-acc[data-step="' + id + '"]'); if (a && a.scrollIntoView) a.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    }
    function collapseOpenThen(cb) {
      var b = root.querySelector('.kfx-acc[data-active="true"] .kfx-acc__body');
      if (!b) { cb(); return; }
      b.style.overflow = 'hidden'; b.style.height = b.scrollHeight + 'px'; b.style.transition = 'height .22s ease, opacity .16s ease, padding .22s ease';
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.style.height = '0px'; b.style.opacity = '0'; b.style.paddingTop = '0'; b.style.paddingBottom = '0'; }); });
      var done = false, fin = function () { if (done) return; done = true; cb(); };
      b.addEventListener('transitionend', fin, { once: true }); setTimeout(fin, 300);
    }
    function setOpen(id) {
      if (layerEls[id]) flashZone(id);
      st.persTab = null;
      if (isDesktop() && st.open && st.open !== id) collapseOpenThen(function () { st.open = id; render(); if (id) scrollAccIntoView(id); });
      else { st.open = id; render(); if (id) scrollAccIntoView(id); }
    }
    function renderCta(cur, mode) {
      el.ctaC.textContent = cur ? ('✓  ' + ((mode === 'personalize' && !st.persTab) ? 'Save personalization' : 'Confirm choice')) : (opts.doneLabel || 'Continue to delivery');
    }

    function showToast(msg) { el.toastMsg.textContent = msg; el.toast.hidden = false; }
    q('[data-kf-toast-x]').addEventListener('click', function () { el.toast.hidden = true; });
    el.back.addEventListener('click', function () {
      if (st.open === 'personalize' && st.persTab) { st.persTab = null; render(); return; }
      st.open = null; render();
    });
    el.cta.addEventListener('click', function () {
      el.toast.hidden = true;
      if (st.open === 'personalize' && st.persTab) { st.persTab = null; render(); return; }
      if (st.open) { setOpen(null); return; }
      if (!st.size) { st.open = 'size'; render(); showToast('Choose your size to continue — your design is saved.'); return; }
      if (opts.onDone) opts.onDone(api.get());
    });

    // Desktop: fit the designer between the page header and the bottom of the window (as the original).
    function sizeVh() {
      var top = root.getBoundingClientRect().top + window.pageYOffset;
      root.style.setProperty('--kf-vh', Math.max(420, window.innerHeight - top) + 'px');
    }
    window.addEventListener('resize', sizeVh);
    if (mq.addEventListener) mq.addEventListener('change', function () { st.open = null; render(); layoutName(); sizeVh(); });

    var api = {
      get: function () {
        return {
          size: st.size ? st.size.key : null,
          zones: cfg.zones.map(function (z) { return { z: z.key, o: st.sel[z.key].key }; }),
          name: st.name.trim(), date: st.date.trim(), font: st.font.key, textColor: st.textColor.key
        };
      },
      set: function (d) {
        if (!d) return;
        (d.zones || []).forEach(function (sav) {
          var z = byKey(cfg.zones, sav.z); if (!z) return;
          var o = byKey(z.options, sav.o); if (!o) return;
          st.sel[z.key] = o; layerEls[z.key].src = asset(o.asset);
        });
        st.size = byKey(cfg.size.options, d.size) || null;
        st.name = String(d.name || '').slice(0, MAXN);
        st.date = String(d.date || '');
        st.font = byKey(cfg.text.fonts, d.font) || cfg.text.fonts[0];
        st.textColor = byKey(cfg.text.colors, d.textColor) || cfg.text.colors[0];
        el.nameOv.style.color = st.textColor.hex;
        applyFont(st.font); updateName(); render();
      },
      // Same measurement as the live customizer's _kf_name_pos, so the cart/admin picture matches.
      namePos: function () {
        if (!st.name.trim() || el.nameOv.hidden) return '';
        var b = el.base.getBoundingClientRect(), n = el.nameOv.getBoundingClientRect();
        if (!b.width || !b.height) return '';
        var fs = parseFloat(el.nameOv.style.fontSize) || 0;
        return [
          ((n.left + n.width / 2 - b.left) / b.width * 100).toFixed(2),
          ((n.top + n.height / 2 - b.top - NAME_DROP * fs) / b.height * 100).toFixed(2),
          (cfg.text.pos.rotation || 0),
          (fs * FIT / b.width * 100).toFixed(3)
        ].join(',');
      },
      setSaved: function (text) { el.saved.textContent = text; el.dsaved.textContent = text; },
      relayout: function () { sizeVh(); layoutName(); render(); }
    };

    refreshTop(); render(); layoutName(); sizeVh();
    if (opts.initial) api.set(opts.initial);
    return api;
  }

  window.GiftDesigner = { mount: mount, preview: preview, sizeLabel: sizeLabel };
})();
